<p>progress-bar works : {{ textKey }} ({{ percentageInSection | percent }})<i> {{ pictures.join(" - ") }} </i></p>
